import { useTranslate } from "@refinedev/core";
import { Grid2 as Grid, Typography } from "@mui/material";

import { Form } from "@shared/components";

export function ReferralProgramFields() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Typography style={{ fontSize: 18, color: "primary.main" }}>
          {translate("v1/agreement_admin.sections.referral_program")}
        </Typography>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Editor
          name="referral_offer"
          label={translate("v1/agreement_admin.fields.referral_offer")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="referral_value"
          label={translate("v1/agreement_admin.fields.referral_value")}
          mask="currency"
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.SinglePhotoPicker
          name="referral_image"
          label={translate("v1/agreement_admin.fields.referral_image")}
          shape="square"
          size={150}
        />
      </Grid>
    </Grid>
  );
}
